"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _reactRouter = require("react-router");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _path = _interopRequireDefault(require("../../helpers/path"));
var _MenuItemComponent = _interopRequireDefault(require("../MenuItem/MenuItemComponent"));
var _APIcon = _interopRequireDefault(require("../common/APIcon"));
require("./WalletDetailsBackButton.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClass = (0, _cssClassesHelper.getBEMClasses)('wallet-details-back-button');
var WalletDetailsBackButtonComponent = function WalletDetailsBackButtonComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('user'),
    t = _useTranslation.t;
  var walletsPath = '/wallets';
  return /*#__PURE__*/_react["default"].createElement(_MenuItemComponent["default"], {
    customClass: baseClass(),
    onItemClick: function onItemClick() {
      return props.history.push((0, _path["default"])(walletsPath));
    }
  }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
    name: "arrowPrevious",
    customClass: baseClass()
  }), " ", t('Back to Overview'));
};
WalletDetailsBackButtonComponent.propTypes = {
  history: _propTypes["default"].object.isRequired,
  isMarginSelected: _propTypes["default"].bool.isRequired
};
var mapStateToProps = function mapStateToProps(state) {
  var selectedAccountId = state.user.selectedAccountId,
    accountInfo = state.margin.accountInfo;
  var isMarginSelected = selectedAccountId === accountInfo.AccountId;
  return {
    isMarginSelected: isMarginSelected
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)((0, _reactRouter.withRouter)(WalletDetailsBackButtonComponent));